<div class="main-layout" [class.main-layout-fullscreen]="layoutFullscreen()">
  @if (!layoutFullscreen()) {
    <nav
      class="navbar navbar-light bg-white border-bottom px-3 d-flex justify-content-between align-items-center">
      <div class="logo d-flex align-items-center" routerLink="/">
        <img
          class="logo__emblem"
          src="assets/image/logo-gso-alt.svg"
          alt="GSO emblem"
          height="32" />

        <img
          class="logo__wordmark"
          src="assets/image/gso.svg"
          alt="Global Second Opinion"
          height="20" />
      </div>

      <div class="d-flex align-items-center gap-3">
        <app-language-switcher />
        <app-user-menu />
        <button
          class="btn btn-link p-0 d-md-none flex-shrink-0"
          [attr.aria-label]="'NAVIGATION.OPEN_MENU' | translate"
          (click)="mobileMenuOpen = true">
          <ng-icon name="bootstrapList" size="1.5rem" />
        </button>
      </div>
    </nav>
  }

  @if (!layoutFullscreen()) {
    <aside class="sidebar d-none d-md-flex flex-column">
      <app-menu [items]="menuItems"></app-menu>
      <div
        class="version mt-auto p-3 text-center small text-muted"
        (mouseenter)="versionMouseOver = true"
        (mouseleave)="versionMouseOver = false">
        <span
          [style.visibility]="
            versionMouseOver || devMode ? 'visible' : 'hidden'
          "
          >{{ applicationVersion }}</span
        >
        @if (environmentName) {
          <span
            [style.visibility]="
              versionMouseOver || devMode ? 'visible' : 'hidden'
            ">
            [{{ environmentName }}]</span
          >
        }
      </div>
    </aside>
  }

  <!-- CONTENT -->
  <main
    class="main-content"
    [class.main-content-flush]="flushLayout()"
    [class.main-content-layout-fullscreen]="layoutFullscreen()">
    <div class="page-content-wrapper">
      @if (pageHeader(); as header) {
        <h5 class="fw-bold mt-3 mb-3">{{ header | translate }}</h5>
      }
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

@if (!layoutFullscreen()) {
  <div class="mobile-drawer" [class.open]="mobileMenuOpen">
    <div
      class="drawer-header d-flex justify-content-between align-items-center px-3 py-3 border-bottom">
      <img
        class="logo__emblem logo__emblem--mobile"
        src="assets/image/logo-gso-alt.svg"
        alt="GSO emblem"
        height="40" />

      <img
        class="logo__wordmark logo__wordmark--mobile"
        src="assets/image/gso.svg"
        alt="Global Second Opinion"
        height="24" />

      <button class="btn btn-link p-0" [attr.aria-label]="'NAVIGATION.CLOSE_MENU' | translate" (click)="mobileMenuOpen = false">
        <ng-icon name="bootstrapXLg" size="1.5rem" />
      </button>
    </div>

    <div class="p-3 d-flex flex-column">
      <app-menu
        [items]="menuItems"
        (redirected)="mobileMenuOpen = false"></app-menu>
      <div
        class="version mt-3 pt-3 text-center small text-muted border-top"
        (mouseenter)="versionMouseOver = true"
        (mouseleave)="versionMouseOver = false">
        <span
          [style.visibility]="
            versionMouseOver || devMode ? 'visible' : 'hidden'
          "
          >{{ applicationVersion }}</span
        >
        @if (environmentName) {
          <span
            [style.visibility]="
              versionMouseOver || devMode ? 'visible' : 'hidden'
            ">
            [{{ environmentName }}]</span
          >
        }
      </div>
    </div>
  </div>
}
